<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    export default {
        name: 'tags',
        data () {
            return {}
        },
    }
</script>



// WEBPACK FOOTER //
// Tags.vue?11feb257